import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IonicModule} from "@ionic/angular";
import {CardModule} from "../../../../../../core/component/card/card.module";
import {SaleProductsCardComponent} from "./sale-products-card.component";
import {SaleProductsCardRowModule} from "../../../impl/component/sale-product-card-row/sale-products-card-row.module";
import {DatatableDataModule} from "../../../../../../core/component/datatable-data/datatable-data.module";
import {ViewByIdDefaultModule} from "../../../../../../core/component/view-by-id-default/view-by-id-default.module";
import {PriceLabelModule} from "../../../../../../common/price/api/component/price-label/price-label.module";
import {ButtonModule} from "../../../../../../core/component/button/button.module";
import {
    SaleChangeMultipleProductsPriceDialogComponent
} from "../sale-change-multiple-products-price-dialog/sale-change-multiple-products-price-dialog.component";
import {
    SaleProductAddDialogComponent
} from "../../../../../api/component/sale-product-add-dialog/sale-product-add-dialog.component";
import {CardV2Component} from "../../../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        CardModule,
        DatatableDataModule,
        SaleProductsCardRowModule,
        ViewByIdDefaultModule,
        PriceLabelModule,
        ButtonModule,
        SaleChangeMultipleProductsPriceDialogComponent,
        SaleProductAddDialogComponent,
        CardV2Component
    ],
    declarations: [
        SaleProductsCardComponent,
    ],
    exports: [
        SaleProductsCardComponent
    ],
})
export class SaleProductsCardModule {
}
